import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const TasProgramTemplateInstitutionSchema = withDefaults({
  type: 'tas-program-template-institution',
  objectExtensions: ['tas-program-template-institution'],
  fields: [
    {
      kind: 'attribute',
      name: 'isFeatured',
    },
    {
      kind: 'attribute',
      name: 'isPreferred',
    },
    {
      kind: 'belongsTo',
      name: 'tasProgramTemplate',
      type: 'tas-program-template',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'belongsTo',
      name: 'logo',
      type: 'public-asset',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'belongsTo',
      name: 'accreditedInstitution',
      type: 'dapip-institution-campus-view',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'belongsTo',
      name: 'unaccreditedInstitution',
      type: 'tas-unaccredited-institution',
      options: {
        async: false,
        inverse: null,
      },
    },
  ],
});

export default TasProgramTemplateInstitutionSchema;
